import { api } from './client';

export interface ApiKeyInfo {
  id: string;
  keyPrefix: string;
  label: string;
  lastUsedAt: string | null;
  createdAt: string;
}

export const keysApi = {
  list: () => api.get<{ keys: ApiKeyInfo[] }>('/keys'),
  create: (label: string) => api.post<{ key: string; id: string; prefix: string; label: string; _notice: string }>('/keys', { label }),
  revoke: (id: string) => api.delete<{ message: string }>(`/keys/${id}`),
};
